import request from '@/utils/request'


export function getCrewList(query) {
    return request({
        url: '/crew/crew',
        method: 'get',
        params: query
    })
}

export function getCrewInfo(query) {
    return request({
        url: '/crew/crew-info',
        method: 'get',
        params: query
    })
}

export function CreateCrew(data){
    return request({
        url: '/crew/crew',
        method: 'post',
        data
    })
  }

export function UpdateCrew(data){
    return request({
        url: '/crew/update-crew',
        method: 'post',
        data
    })
  }

export function deleteCrew(query) {
    return request({
        url: '/crew/update-crew',
        method: 'get',
        params: query
    })
}


export function getCrewServiceList(query) {
    return request({
        url: '/crew/crew-service',
        method: 'get',
        params: query
    })
}

export function CreateCrewService(data){
    return request({
        url: '/crew/crew-service',
        method: 'post',
        data
    })
  }

export function UpdateCrewService(data){
    return request({
        url: '/crew/update-crew-service',
        method: 'post',
        data
    })
  }

export function deleteCrewService(query) {
    return request({
        url: '/crew/update-crew-service',
        method: 'get',
        params: query
    })
}

export function getServiceInfo(query) {
    return request({
        url: '/crew/service-info',
        method: 'get',
        params: query
    })
}